import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "common-self-haul-info-modal",
  templateUrl: "./self-haul-info-modal.component.html",
  styleUrls: ["./self-haul-info-modal.component.scss"],
})
export class SelfHaulInfoModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.close(false);
  }
}
